import { useReduxSelector } from 'shared/hooks/useReduxSelector';
import { coworkingOperatorLogoSelector } from 'shared/store/coworking/selectors/dump/coworkingOperatorLogoSelector';

export function useCoworkingOperatorLogoSelector(): string {
  return useReduxSelector<string>(coworkingOperatorLogoSelector);
}
